/* eslint-disable react/display-name */
import React, { useState, useEffect , useRef } from 'react';
import { useQuery, gql, useApolloClient, useLazyQuery } from '@apollo/client';
import { withTranslation } from 'react-i18next';
import CustomLoader from '../components/Loader/CustomLoader';
// core components
import Header from '../components/Headers/Header';
import { gettallcustomers, GetAllCustomerTypes, SearchCustomers as SearchCustomersQuery, getCustomerReportWithOrderCount} from '../apollo'; // Import the search query
import DataTable from 'react-data-table-component';
import orderBy from 'lodash/orderBy';
import {
    Container, Button, useTheme,
    Box,
     FormControl, InputLabel, MenuItem, Select 
} from '@mui/material';
import { Icon } from '@iconify/react';

import { customStyles } from '../utils/tableCustomStyles';
import useGlobalStyles from '../utils/globalStyles';
import TableHeader from '../components/TableHeader';
import SearchBar from '../components/TableHeader/SearchBar'; // Import SearchBar
// import TuneIcon from '@mui/icons-material/Tune'; // Import TuneIcon - Removed
const LAST_CUSTOMER_LIST_PAGE = 'lastCustomerListPage';
const LAST_CUSTOMER_LIST_SCROLL_POS = 'lastCustomerListScrollPos'; // To store scroll position
const IS_BACK_NAVIGATION = 'isBackNavigation'; // Flag for back navigation
const LAST_CUSTOMER_LIST_PER_PAGE = 'lastCustomerListPerPage'; // Use a constant for this too
const LAST_SELECTED_CUSTOMER_ID = 'lastSelectedCustomerId'; // <-- Add this new constant

const GET_CUSTOMER_TYPE = gql`
    ${GetAllCustomerTypes}
`;

const GET_ALL_CUSTOMERS = gql`
    ${gettallcustomers}
`;

const SEARCH_CUSTOMERS = gql`
    ${SearchCustomersQuery}
`;
const GET_CUSTOMER_REPORT_WITH_ORDER_COUNT = gql`
  ${getCustomerReportWithOrderCount}
`;
const AllCustomerList = props => {
    const { t, history } = props; // Destructure history from props
    const globalClasses = useGlobalStyles();
    const [data, setData] = useState([]); // Initialize data as an empty array
    const client = useApolloClient();
    const [tabledata, setTabledata] = useState([])
    const [page, setPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(page);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [csvData, setCsvData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchField, setSearchField] = useState(null);
    const tableRef = useRef(null); // Ref for the DataTable
    const [reload, setReload] = useState(false);
     // State to hold the selected customer ID for highlighting (optional)
    const [selectedCustomerId, setSelectedCustomerId] = useState(null);

    // Effect to handle initial load and back navigation
    const [readyToQuery, setReadyToQuery] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);
    const handleCloseMenu = () => setAnchorEl(null);
    const [selectedDownloadType, setSelectedDownloadType] = useState("data");


useEffect(() => {
    const storedPage = localStorage.getItem(LAST_CUSTOMER_LIST_PAGE);
    const storedScrollPos = localStorage.getItem(LAST_CUSTOMER_LIST_SCROLL_POS);
    const storedPerPage = localStorage.getItem(LAST_CUSTOMER_LIST_PER_PAGE); // Use the constant
    const storedSelectedId = localStorage.getItem(LAST_SELECTED_CUSTOMER_ID); // <-- Retrieve the selected ID
     const storedSearchQuery = localStorage.getItem('lastCustomerSearchQuery');  
  const storedSearchField = localStorage.getItem('lastCustomerSearchField'); 
    const backNavigated = localStorage.getItem(IS_BACK_NAVIGATION) === 'true';
   
    const navigatedFromCustomerDetails = history.action === 'POP' &&
        history.location &&
        history.location.state &&
        history.location.state.fromCustomerDetails;

    if (backNavigated && storedPage) {
        const parsedPage = parseInt(storedPage, 10);
        setPage(parsedPage);
        setCurrentPage(parsedPage);
        if (storedPerPage) {
            setPerPage(parseInt(storedPerPage, 10));
        }
        if (storedScrollPos && tableRef.current) {
            setTimeout(() => {
                tableRef.current.parentElement.parentElement.scrollTo(0, parseInt(storedScrollPos, 10));
            }, 100);
        }
        if (storedSelectedId) { // <-- If a selected ID was found
            setSelectedCustomerId(storedSelectedId); // <-- Set it to state
        }
         if (storedSearchQuery) setSearchQuery(storedSearchQuery);        //  restore search
        if (storedSearchField) setSearchField(storedSearchField);        // restore field
         

        // Clean up the localStorage flags/items after use
        localStorage.removeItem(IS_BACK_NAVIGATION);
        localStorage.removeItem(LAST_CUSTOMER_LIST_PER_PAGE); // Use the constant
        localStorage.removeItem(LAST_SELECTED_CUSTOMER_ID); // <-- Clear the selected ID from storage
        localStorage.removeItem('lastCustomerSearchQuery');             //  cleanup
        localStorage.removeItem('lastCustomerSearchField');
      } else if (!navigatedFromCustomerDetails) {
        // Clear all relevant localStorage items on a "fresh" (non-back) navigation
        setPage(1);
        setCurrentPage(1);
        localStorage.removeItem(LAST_CUSTOMER_LIST_PAGE);
        localStorage.removeItem(LAST_CUSTOMER_LIST_SCROLL_POS);
        localStorage.removeItem(IS_BACK_NAVIGATION);
        localStorage.removeItem(LAST_CUSTOMER_LIST_PER_PAGE); // Use the constant
        localStorage.removeItem(LAST_SELECTED_CUSTOMER_ID); // <-- Clear on fresh load too
        localStorage.removeItem('lastCustomerSearchQuery');             //  cleanup
        localStorage.removeItem('lastCustomerSearchField');
      }

    // Mark ready after values are restored
    setReadyToQuery(true);
}, [history.action, history.location.state]); // Dependencies remain the same


    const variables = {
        limit: perPage,
        skip: (page - 1) * perPage,
    };

    const variablesSearch = {
        text: searchQuery,
        limit: perPage,
        skip: (page - 1) * perPage,
        searchField: searchField === 'phone' ? 'phoneNumber' : searchField,
    };

    const { data: workerStatus } = useQuery(GET_CUSTOMER_TYPE, {
        onError: (error) => {
            const isForbiddenError = error && error.graphQLErrors.some((err) => err.extensions.code === 'FORBIDDEN');
            if (isForbiddenError) {
                localStorage.removeItem('user-native');
                localStorage.removeItem('restaurant_id');
                client.clearStore();
                props.history.push('/auth/login');
            }
        },
    });

    const optionsworkerStatus = workerStatus
        ? workerStatus.getAllCustomerTypes.map((type) => ({
            label: type.name,
            customerType: type.customerType
        }))
        : [];

    const getCustomerTypeName = (customerTypeId) => {
        const customerType = optionsworkerStatus.find(type => type.customerType === customerTypeId);
        return customerType ? customerType.label : 'N/A';
    };

    const { loading: loadingQuery, refetch } = useQuery(GET_ALL_CUSTOMERS, {
      fetchPolicy: 'network-only',
       variables: {
    limit: perPage,
    skip: (page - 1) * perPage,
  },
        skip: !!searchQuery || !readyToQuery,// Skip this query if searching
      onCompleted: (data) => {
        const customers = data && data.getCustomersForCentralStore ? data.getCustomersForCentralStore.customers : [];
        const mappedCustomers = customers.map(customer => ({
          ...customer,
          phoneNumber: customer.phone || customer.phoneNumber,
        }));
        if (!searchQuery) {
          setData(mappedCustomers);
          setTabledata(mappedCustomers);
          setTotalRows(data && data.getCustomersForCentralStore ? data.getCustomersForCentralStore.totalCount : 0);
          //console.log("Query fired with limit =", perPage, "skip =", (page - 1) * perPage);

        }
       
      },
        onError: error => {
            const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
            if (isForbiddenError) {
                localStorage.removeItem('user-native');
                localStorage.removeItem('restaurant_id');
                client.clearStore();
                props.history.push('/auth/login');
            }
        },
    });

    const [searchCustomers, { data: searchData, loading: searchLoading }] = useLazyQuery(SEARCH_CUSTOMERS, {
  fetchPolicy: 'no-cache',
  onCompleted: (data) => {
    if (data && data.searchCustomers) {
      setData(data.searchCustomers.customers || []);
      setTotalRows(data.searchCustomers.totalCount || 0);
    }
  },
  onError: error => {
            const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
            if (isForbiddenError) {
      localStorage.removeItem('user-native');
      localStorage.removeItem('restaurant_id');
      client.clearStore();
      props.history.push('/auth/login');
    }
  }
});
const [fetchCustomerReport] = useLazyQuery(
  GET_CUSTOMER_REPORT_WITH_ORDER_COUNT,
  {
    fetchPolicy: "network-only",

    onCompleted: (data) => {
      const customers =
        data &&
        data.getCustomerReportWithOrderCount &&
        data.getCustomerReportWithOrderCount.customers
          ? data.getCustomerReportWithOrderCount.customers
          : [];

      downloadNewCustomerCSV(customers);
    },

    onError: (err) => {
      console.error("Download Error:", err.message);
    },
  }
);
 useEffect(() => {
      let customers = [];
      if (searchQuery) {
        customers = searchData && searchData.searchCustomers && searchData.searchCustomers.customers
          ? searchData.searchCustomers.customers.map(customer => ({
              ...customer,
              phoneNumber: customer.phone || customer.phoneNumber,
            }))
          : [];
      } else {
        customers = (data && data.getCustomersForCentralStore && data.getCustomersForCentralStore.customers) || [];
      }
      setTabledata(customers);
      //console.log("Table Data:", tabledata); // Keep this for debugging
    }, [searchQuery, searchData]); // REMOVED 'data' from the dependency array
    const [refetchCustomerDataForCSV] = useLazyQuery(GET_ALL_CUSTOMERS, {
        fetchPolicy: 'network-only',
        
        onCompleted: (data) => {
            let dataCvs = data && data.getCustomersForCentralStore ? data.getCustomersForCentralStore.customers : [];
            setCsvData(data && data.getCustomersForCentralStore ? data.getCustomersForCentralStore.customers : []);
            setTotalRows(data.getCustomersForCentralStore.totalCount);
            downloadCSV(dataCvs);
        },
        onError: error => {
            const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
            if (isForbiddenError) {
                localStorage.removeItem('user-native');
                localStorage.removeItem('restaurant_id');
                client.clearStore();
                props.history.push('/auth/login');
            }
        },
    });
 useEffect(() => {
  if (readyToQuery && searchQuery) {
    searchCustomers({
      variables: {
        text: searchQuery,
        searchField: searchField === 'phone' ? 'phoneNumber' : searchField,
        limit: perPage,
        skip: (page - 1) * perPage,
      }
    });
  }
}, [page, perPage]); // Re-fire on page change


   useEffect(() => {
    if (searchQuery) {
        searchCustomers({ variables: variablesSearch }); //  use useLazyQuery instead
    }
}, [searchQuery, searchField]);




    const handleFetchStatsCVS = () => {
        refetchCustomerDataForCSV({
            variables: {
                limit: totalRows ? totalRows : 1000000, // Fetch all rows
                skip: 0,
            }
        });
    };

    // const handlePerRowChange = (newPerPage) => {
    //     setPerPage(newPerPage);
    //     setPage(1); // Reset page on perPage change
    // };
    const handlePerRowChange = (newPerPage) => {
  //console.log('[handlePerRowChange] Rows per page changed to:', newPerPage);
  setPerPage(newPerPage);
  setPage(1);
  setCurrentPage(1);
};

const handleDownloadNewCustomerReport = () => {
  fetchCustomerReport({
    variables: {
      skip: 0,
      limit: 1000000, 
    },
  });
};

    const handlePageChange = (newPage) => {
  //console.log('[handlePageChange] Changing to page:', newPage);
  setPage(newPage);
  setCurrentPage(newPage);
};

    const customSort = (rows, field, direction) => {
        const handleField = row => {
            if (row[field]) {
                return row[field].toLowerCase();
            }
            return row[field];
        };
        return orderBy(rows, handleField, direction);
    };
//console.log("Render: perPage =", perPage, "tabledata.length =", tabledata.length);
  
    const columns = [
      {
        name: 'Serial Number',
        // cell: (row, index) => <>{index + 1}</>,
        cell: (row, index) => <>{(currentPage - 1) * perPage + index + 1}</>, // Corrected serial number
        style: { cursor: 'pointer' },
      },
      {
        name: 'Customer Name',
        selector: 'name', // Changed from 'customerName' to 'name'
        style: { cursor: 'pointer' },
      },
      {
        name: 'Customer Type', // Added 'Phone Number' column
        cell: (row) => <>{getCustomerTypeName(row.customerType)}</>,// Added 'phoneNumber' selector
        style: { cursor: 'pointer' },
      },
      {
        name: 'Order Count', // Changed from 'Order Date' to 'Order Count'
        selector: 'orderCount', // Changed from 'orderDate' to 'orderCount'
        cell: (row) => <>{row.orderCount ? row.orderCount : 0}</>,// Added 'phoneNumber' selector
       
        style: { cursor: 'pointer' },
      },
      {
        name: 'Phone Number', // Added 'Phone Number' column
        selector: 'phoneNumber', // Added 'phoneNumber' selector
        style: { cursor: 'pointer' },
      },
      {
        name: 'Delivery Address', // Added 'Delivery Address' column
        cell: (row) =>
          row.addresses && row.addresses.length > 0 ? (
            <>
            {row.addresses[0].details} ,
              {row.addresses[0].deliveryAddress}
            
              
            </>
          ) : (
            ''
          ),
        style: { cursor: 'pointer', minWidth: "300px", textAlign: 'left' },
      },
  
      {
        name: t('Action'),
        cell: (row) => <>{actionButtons(row)}</>,
      },
    ];
  

    const theme = useTheme();

    const downloadCSV = (tableDataCVS) => {
        if (!Array.isArray(tableDataCVS)) {
            return;
        }

        const csvRows = [];
        csvRows.push('');
        const headers = ['Customer Name', 'Customer Type', 'Phone Number', 'Order Count'];
        csvRows.push(headers.join(','));

        tableDataCVS.forEach((row) => {
            const rowData = [
                row.name,
                getCustomerTypeName(row.customerType),
                row.phoneNumber,
                row.orderCount ? row.orderCount : 0,
            ];
            csvRows.push(rowData.join(','));
        });

        const csvContent = `data:text/csv;charset=utf-8,${csvRows.join('\n')}`;
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'customer_details.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
  const downloadNewCustomerCSV = (customers) => {
  if (!customers || customers.length === 0) return;

  const headers = [
    "Name",
    "Phone",
    "Phone Verified",
    "Email",
    "Order Count",
    "Created At",
    "Updated At",
  ];

  const formatDateTime = (value) => {
    if (!value) return "";
    const d = new Date(value);

    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()} ${String(d.getHours()).padStart(
      2,
      "0"
    )}:${String(d.getMinutes()).padStart(2, "0")}:${String(
      d.getSeconds()
    ).padStart(2, "0")}`;
  };

  const rows = customers.map((c) => [
    `"${c.name || ""}"`,
    `"${c.phone || ""}"`,
    `"${c.phoneIsVerified ? "Yes" : "No"}"`,
    `"${c.email || ""}"`,
    `"${c.orderCount || 0}"`,
    `"${formatDateTime(c.createdAt)}"`,
    `"${formatDateTime(c.updatedAt)}"`,
  ]);

  const csvContent = [
    headers.join(","),
    ...rows.map((r) => r.join(",")),
  ].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "customer_report.csv";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};




    const actionButtons = row => {
        return (
            <>
                <Button
                    size="20px"
                    variant="contained"
                    sx={{
                        fontWeight: 'bold',
                        backgroundColor: theme.palette.warning.dark,
                        color: theme.palette.common.white,
                        padding: 0,
                        height: '15px',
                        fontSize: '7px',
                        '&:hover': {
                            border: '2px solid #637BFE',
                            color: theme.palette.warning.dark,
                            backgroundColor: "white"
                        }
                    }}
                    onClick={e => {
                        e.preventDefault();
                    // Save current page and scroll position before navigating
                    localStorage.setItem(LAST_CUSTOMER_LIST_PAGE, page.toString());
                    if (tableRef.current) {
                        localStorage.setItem(LAST_CUSTOMER_LIST_SCROLL_POS, tableRef.current.parentElement.parentElement.scrollTop.toString());
                    }
                    localStorage.setItem(IS_BACK_NAVIGATION, 'true'); // Set flag for back navigation
                    localStorage.setItem(LAST_CUSTOMER_LIST_PER_PAGE, perPage.toString()); // Use the constant
                    localStorage.setItem(LAST_SELECTED_CUSTOMER_ID, row._id); // <-- Store the selected ID here
                    localStorage.setItem('lastCustomerSearchQuery', searchQuery);      // ✅ store current search
                    localStorage.setItem('lastCustomerSearchField', searchField);      // ✅ store field

                    setSelectedCustomerId(row._id); // This line is good for immediate feedback if the component didn't unmount, but localStorage is for persistence.

                    const customerTypeLabel = getCustomerTypeName(row.customerType);
                    localStorage.setItem('customerTypeLabel', JSON.stringify(customerTypeLabel));
                    localStorage.setItem('customerDetails', JSON.stringify(row));

                        const userType = JSON.parse(localStorage.getItem('user-native')).userType;
                        let routePath = '';
                        switch (userType) {
                            case 0:
                                routePath = '/super_admin/customerdetails';
                                break;
                            case 1:
                                routePath = '/cs_admin/customerdetails';
                                break;
                            case 3:
                                routePath = '/local_admin/customerdetails';
                                break;
                            default:
                                routePath = '/cs_admin/customerdetails';
                                break;
                        }
                        props.history.push({
                            pathname: routePath,
                             state: { data: row, fromCustomerList: true } // Add a flag to identify navigation origin
                        });
                    }}
                >
                    {t('ViewDetails')}
                </Button>
            </>
        );
    };


    const handleSearch = () => {
  setPage(1);
  setCurrentPage(1);
  searchCustomers({ variables: variablesSearch }); // trigger the query
};

    const onClickRefetch = () => {
      setSearchQuery('');
      setPage(1);
      setCurrentPage(1); // Reset currentPage as well
      refetch({
        variables: {
          limit: perPage,
          skip: 0,
        },
      });
    };
    const handleSearchFieldChange = (event) => {
        setSearchField(event.target.value);
    };
 // Custom row styling for highlighting selected customer
    const conditionalRowStyles = [
        {
            when: row => row._id === selectedCustomerId,
            style: {
                backgroundColor: theme.palette.action.selected, // Or any highlighting color
            },
        },
    ];

    return (
      <>
        <Header />
  
        <Container className={globalClasses.flex} fluid>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", mb: 3,
      mt: 2   }}>

         
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            
          < FormControl sx={{ minWidth: 180 }}>
          <InputLabel id="download-type-label" sx={{ color: "black" }}>
            {t("Download CSV")}
          </InputLabel>

          <Select
            labelId="download-type-label"
            label={t("Download CSV")}
            value={selectedDownloadType}
            onChange={(e) => setSelectedDownloadType(e.target.value)}
            sx={{
              height: 40,
              borderRadius: "6px",
              backgroundColor: "white",
              color: "black",
              "& .MuiSelect-select": { color: "black" }
            }}
          MenuProps={{
            PaperProps: {
              sx: {
                "& .MuiMenuItem-root": {
                  color: "black !important",
                  fontWeight: 500,
                },
                "& .MuiMenuItem-root.Mui-selected": {
                  backgroundColor: "#E3F0FF !important",
                  color: "black !important",
                },
                "& .MuiMenuItem-root:hover": {
                  backgroundColor: "#4D7CFE !important",
                  color: "white !important",
                }
              }
            }
          }}
        >
          <MenuItem value="data">{t("Customers Data")}</MenuItem>
          <MenuItem value="report">{t("Customers Report")}</MenuItem>
        </Select>
            </FormControl>

            <Button
              onClick={() => {
                if (selectedDownloadType === "data") {
                  handleFetchStatsCVS();
                } else {
                  handleDownloadNewCustomerReport();
                }
              }}
              sx={{
                height: 40,
                width: 48,
                backgroundColor: "#4D7CFE",
                color: "white",
                borderRadius: "6px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                "&:hover": { backgroundColor: "#3c6df2" }
              }}
            >
              <Icon icon="ic:round-download" style={{ fontSize: 22 }} />
            </Button>

          </Box>
  
          </Box>
          {loadingQuery ? (
            <CustomLoader />
          ) : (
            <DataTable
            key={perPage} 
            ref={tableRef} // Attach ref to DataTable
            customStyles={customStyles}
            subHeader={true}
            subHeaderComponent={
              <SearchBar
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder={t(searchField ? `Search by ${t(searchField === 'phone' ? 'Phone' : 'Name')}` : 'Search')}
              onSearch={handleSearch}
              onClear={onClickRefetch}
              onClick={() => onClickRefetch(refetch)}
              />
            }
              title={<TableHeader title='All Customers' />}
              columns={columns}
              data={tabledata}
              progressPending={loadingQuery || searchLoading}
              progressComponent={<CustomLoader />}
              paginationPerPage={perPage}  
              paginationDefaultPage={currentPage}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowChange}
              onChangePage={handlePageChange}
              sortFunction={customSort}
               conditionalRowStyles={conditionalRowStyles} // Apply conditional styles
            />
          )}
        </Container>
      </>
    )
  }
  export default withTranslation()(AllCustomerList)
